// extracted by mini-css-extract-plugin
module.exports = {"formGrid":"doctorsData_formGrid__1ZQ_F","formSubGrid":"doctorsData_formSubGrid__dCESP"};